/* eslint-disable no-console */
import { initializeOpenAIWidget, destroyAllOpenAIWidgets } from '../openai/openaiWidget';
import { initializeAWSWidget, destroyAWSWidget } from '../aws/awsWidget';
import { subscribeLiveAgentChannel, unsubscribeLiveAgentChannel } from './liveAgentChannel';
import { fetchChatkitConversation, destroyChatkitConversation } from './apiRoutes';
import * as toggleHandler from './toggleHandler';
import * as endChatHandler from './endChatHandler';

const AGENT_NAME = 'Live Agent';
const CHATKIT_OPEN_STORAGE_KEY = 'chatkit-open';
let widgetInitialized = false;

async function initializeWidget() {
  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const conversation = await fetchChatkitConversation();
  const threadId = conversation?.open_ai_chatkit_thread_id;
  const initialOptions = threadId ? { initialThread: threadId } : {};
  await initializeOpenAIWidget(container, initialOptions);
  subscribeLiveAgentChannel(container);
  widgetInitialized = true;
}

export function destroyAllWidgets() {
  unsubscribeLiveAgentChannel();
  destroyAllOpenAIWidgets();
  const awsChatkit = document.querySelector('#chatkit-widget-container aws-chatkit');
  destroyAWSWidget(awsChatkit);
  widgetInitialized = false;
}

export function setupWidgetButtons() {
  toggleHandler.setup();
  endChatHandler.setup();

  if (localStorage.getItem(CHATKIT_OPEN_STORAGE_KEY) === 'true') {
    toggleHandler.toggle();
  }
}

export function cleanupWidgetButtons() {
  toggleHandler.cleanup();
  endChatHandler.cleanup();
}

async function switchToLiveAgent(liveAgentData) {
  await destroyChatkitConversation();
  destroyAllWidgets();

  const container = document.getElementById('chatkit-widget-container');
  if (!container) return;

  const openaiChatkit = container.querySelector('openai-chatkit');
  const awsChatkit = container.querySelector('aws-chatkit');
  openaiChatkit.classList.add('d-none');
  awsChatkit.classList.remove('d-none');
  container.querySelector('.agent-name').textContent = AGENT_NAME;

  initializeAWSWidget(awsChatkit, liveAgentData);
}

let pendingLiveAgentData = null;

document.addEventListener('chatkit.toggle.open', async () => {
  localStorage.setItem(CHATKIT_OPEN_STORAGE_KEY, 'true');
  if (!widgetInitialized) await initializeWidget();
});

document.addEventListener('chatkit.toggle.close', () => {
  localStorage.removeItem(CHATKIT_OPEN_STORAGE_KEY);
});

document.addEventListener('chatkit.end-chat', async () => {
  localStorage.removeItem(CHATKIT_OPEN_STORAGE_KEY);
  await destroyChatkitConversation();
});

document.addEventListener('chatkit.live-agent-request', (event) => {
  pendingLiveAgentData = event.detail;
});

document.addEventListener('chatkit.response.end', () => {
  if (!pendingLiveAgentData) return;

  const data = pendingLiveAgentData;
  pendingLiveAgentData = null;
  setTimeout(() => switchToLiveAgent(data), 3000);
});
